'use strict';

import delegateListener from '../modules/delegate-listener';
import $ from 'jquery';

/**
 * This module handles ajax forms and other form related stuff
 */
class FormHelper {
  constructor(options) {
    const defaults = {
      formSelector: '.ajax-form',
      messageClass: 'ajax-message',
    };

    this.settings = Object.assign({}, defaults, options);
    this.s = this.settings;
  }

  /**
   * Initialize the module
   */
  init() {
    this._forms = Array.from(document.querySelectorAll(this.s.formSelector));
    this._bindEvents();
    this.updateTokens();
  }

  /**
   * Updates all [name="cm_token"] fields with current user csrf token
   */
  updateTokens() {
    const $tokenFields = $('[name="cm_token"]');

    if ($tokenFields.length === 0) return;

    $.get('/api/1.0.0/token').done(result => {
      if (typeof result === 'object' && result && typeof result.cm_token === 'string') {
        $tokenFields.val(result.cm_token);
      }
    });
  }

  /**
   * Perform an action specified in the form's data-action attribute.
   *
   * @param {HTMLElement} form    The form element
   * @param {string}      action  The action to perform
   */
  _performAction(form, action) {

    switch (action) {
    case 'initiate-payment': {
      let pid = window.ORDER_PID;
      $.ajax({
        url: '/api/1.0.0/order/'+pid+'/initiate-payment',
        type: 'POST',
        data: JSON.stringify({order: pid, reservation: window.PRICE_RESERVATION}),
        contentType: 'application/json'
      }).done((data, textStatus, jqxhr) => {
        if (data.status === 'OK' && typeof data.redirect === 'string') {
          window.location.href = data.redirect;
        }
        if(data.status === 'FAILED' && typeof data.redirect === 'string'){
          // Server response can be found here: jqxhr.responseJSON;
          window.location.href = data.redirect;

        }
      }).always(() => {

      });
      break;
    }
    case 'reserve-product': {
      $.ajax({
        url: '/api/1.0.0/product/' + window.PRODUCT_UUID + '/reserve/',
        type: 'POST',
        data: JSON.stringify({
          cm_token: form.querySelector('input[name="cm_token"]').value
        }),
        contentType: 'application/json'
      }).done((data, textStatus, jqxhr) => {
        if (data.status === 'OK' && typeof data.redirect === 'string') {
          window.location.href = data.redirect;
        }
        if(data.status === 'FAILED'){
          // Server response can be found here: jqxhr.responseJSON;
          let errorMsg = '';

          // TODO: how should errors be displayed?
          data.messages.forEach(m => {
            errorMsg += m + '\n';
          });

          alert(errorMsg);  // eslint-disable-line no-alert
        }
      }).always(() => {
        this._setLoadingState(form, false);
      });
      break;
    }
    // NOT IN USE --- this is done in car-search.js
    case 'search-product': {
      $.ajax({
        url: '/api/1.0.0/product/',
        type: 'POST',
        data: {brand: 'Nissan'}
      }).done((data, textStatus, jqxhr) => {
        if (data.status === 'OK' && typeof data.redirect === 'string') {
          console.log(1233);
        }
      }).fail((jqxhr, textStatus, errorThrown) => {
        // Server response can be found here: jqxhr.responseJSON;
      });
    }
    }
  }

  /**
   * After sending a form, set it to loading state, disable submit buttons etc.
   * After the form is sent and response is received, remove loading state and enable submit buttons etc
   *
   * @param {HTMLElement} form  The form element
   * @param {boolean}     state True for entering loading mode, false for exiting loading mode
   */
  _setLoadingState(form, state) {
    form.querySelector('[type="submit"],button:not([type="button"]):not([type="reset"])').disabled = state;
  }

  /**
   * Update form messages, for example show an error message.
   *
   * @param {HTMLElement}   form      The form element
   * @param {Array}         messages  The error messages as an array or one error message as a string
   * @param {boolean}       success   If false, an error class is added to the message
   */
  _updateMessages(form, messages, success) {
    let messageContainer = form.querySelector('.' + this.s.messageClass);

    if (!messageContainer) {
      // Message container doesn't exist - create it
      messageContainer = document.createElement('div');
      messageContainer.classList.add(this.s.messageClass);
      form.insertBefore(messageContainer, form.childNodes[0]);
    }

    messageContainer.innerHTML = '';

    if (Array.isArray(messages) && messages.length > 0) {
      // Response includes a message. Show it to the user.
      const messagesUl = document.createElement('ul');

      messages.forEach(message => {
        const messageLi = document.createElement('li');
        messageLi.innerHTML = message;
        messagesUl.appendChild(messageLi);
      });

      messageContainer.appendChild(messagesUl);

      messageContainer.classList.add(this.s.messageClass + (success ? '--success' : '--error'));
      messageContainer.classList.remove(this.s.messageClass + (!success ? '--success' : '--error'));
    }
  }

  /**
   * Get data from a form
   *
   * @param   {HTMLElement} form  The form element
   * @returns {Object}            The form data
   */
  _getFormData(form) {
    const inputElements = Array.from(form.querySelectorAll('[name]'));

    let formData = {
      'stage-language': window.lang
    };

    inputElements.forEach(inputElement => {
      switch (inputElement.nodeName) {


      case 'INPUT':
        switch (inputElement.type) {
        case 'text':
        case 'hidden':
        case 'password':
        case 'button':
        case 'reset':
        case 'submit':
        case 'number':
          formData[inputElement.name] = inputElement.value;
          break;
        case 'checkbox':
          if (inputElement.checked) {
            if (typeof formData[inputElement.name] === 'undefined') {
              formData[inputElement.name] = [];
            }
            formData[inputElement.name].push(inputElement.value);
          }
          break;
        case 'radio':
          if (inputElement.checked) {
            formData[inputElement.name] = inputElement.value;
          }
          break;
        case 'file':
          break;
        }
        break;

      case 'TEXTAREA':
        formData[inputElement.name] = inputElement.value;
        break;

      case 'SELECT':
        switch (inputElement.type) {
        case 'select-one':
          formData[inputElement.name] = inputElement.value;
          break;
        case 'select-multiple':
          formData[inputElement.name] = Array.from(inputElement.options).filter(option => option.selected).map(option => option.value);
          break;
        }
        break;

      case 'BUTTON':
        switch (inputElement.type) {
        case 'reset':
        case 'submit':
        case 'button':
          formData[inputElement.name] = inputElement.value;
          break;
        }
        break;
      }
    });
    return formData;
  }

  /**
   * Bind events to elements according to settings
   */
  _bindEvents() {

    const boundHandler = this._handleAjaxForm.bind(this);
    document.body.addEventListener('submit', delegateListener(this.s.formSelector, boundHandler));
  }

  /**
   * Handle the submit event of an ajax form.
   *
   * @param {Object} event The submit event
   */
  _handleAjaxForm(event) {

    const form = event.target;
    event.preventDefault();
    this._updateMessages(form, [], true);
    this._setLoadingState(form, true);
    this._performAction(form, form.getAttribute('data-action'));
  }

}

export default FormHelper;
